import React from 'react';
import ScheduleInterview from '../../pages/hrManagement/scheduleInterview/ScheduleInterview';
import SkillCategory from '../../pages/skills/skillCategory/SkillCategory';
import MainSkill from '../../pages/skills/mainCategory/MainSkill';
import ViewPositionDetail from '../../pages/masterData/position/ViewPositionDetail';

const SystemAction = React.lazy(() => import('../../pages/masterData/systemAction/SystemAction'));
const CandidateReport = React.lazy(() => import('../../pages/reports/candidateReport/CandidateReports'));
const JobReport = React.lazy(() => import('../../pages/reports/jobReport/JobReports'));
const ActivitylogReport = React.lazy(() => import('../../pages/reports/activitylogReport/ActivitylogReports'));

const Position = React.lazy(() => import('../../pages/masterData/position/position'));

const Department = React.lazy(() => import('../../pages/masterData/department/department'));

const addEditDepartment = React.lazy(() => import('../../pages/masterData/department/addEditDepartment'));

//** Dashboard */
const Dashboard = React.lazy(() => import('../../pages/dashboard/Dashboard'));

//** NO Found */
const NotFound = React.lazy(() => import('../../pages/errors/NotFound'));

//**  Candidate */
const CandidateList = React.lazy(() => import('../../pages/hrManagement/candidateList/CandidateList'));
const CandidateDetail = React.lazy(() => import('../../pages/hrManagement/candidateDetail/CandidateDetail'));
const FollowUp = React.lazy(() => import('../../pages/hrManagement/FollowUp/FollowUp'))

/** Manage Skill */
const ManageSkill = React.lazy(() => import('../../pages/masterData/manageSkill/manageSkill'));
const AddEditManageSkill = React.lazy(() => import('../../pages/masterData/manageSkill/addEditManageSkill'));

//** Job Title */
// const Position = React.lazy(() => import('../../pages/masterData/position/position'));
const AddEditPosition = React.lazy(() => import('../../pages/masterData/position/addEditPosition'));

//** Testing  */
const TestTableGrid1 = React.lazy(() => import('../../pages/tableGrid/TestTableGrid1'));
const TestFormField = React.lazy(() => import('../../pages/formField/TestFormField'));

/** Manage Channel */
const ManageChannel = React.lazy(() => import('../../pages/masterData/manageChannel/manageChannel'));
const AddEditManageChannel = React.lazy(() => import('../../pages/masterData/manageChannel/addEditManageChannel'));

/** Manage Source */
const ManageSource = React.lazy(() => import('../../pages/masterData/manageSource/manageSource'));
const AddEditManageSource = React.lazy(() => import('../../pages/masterData/manageSource/addEditManageSource'));

const InterviewRound = React.lazy(() => import('../../pages/masterData/interviewRound/InterviewRound'));

const InterviewType = React.lazy(() => import('../../pages/masterData/interviewType/InterviewType'));

/** Manage Rejected Reason */
const RejectedReason = React.lazy(() => import('../../pages/masterData/rejectedReason/RejectedReason'));

const FollowupReason = React.lazy(() => import('../../pages/masterData/followupReason/FollowupReason'));

/** Manage Question*/
const ManageQuestionList = React.lazy(() => import('../../pages/manageQuestion/ManageQuestionList'));
const AddEditQuestions = React.lazy(() => import('../../pages/manageQuestion/AddEditQuestions'));

const MyInterviewDetails = React.lazy(() => import('../../pages/myInterview/MyInterviewDetails'));

const RecycleBinDelete = React.lazy(() => import('../../pages/recycleBinDelete/RecycleBinDelete'));

/** Manage User*/
const AddEditUser = React.lazy(() => import('../../pages/masterData/manageUser/addEditUser'));
const ManageUserList = React.lazy(() => import('../../features/manageUser/Component/manageUserList'));

const AddEditEmail = React.lazy(() => import('../../pages/masterData/manageEmailTemplate/addEditEmail'));
const ManageEmailList = React.lazy(() => import('../../pages/masterData/manageEmailTemplate/ManageEmail'));

const StatusList = React.lazy(() => import('../../pages/masterData/processStatus/processStatus/StatusList'));

/** Security */
const SecurityRoleManagement = React.lazy(() => import('../../pages/security/securityManagement/SecurityRoleManagement'));
const Permissions = React.lazy(() => import('../../pages/security/permissions/Permissions'));

export const ComponentNavigation = [
    {
        id: 'pageNotFound',
        path: 'pageNotFound',
        exact: true,
        title: '',
        component: NotFound,
        text: 'Page not found',
        roleTypes: [1, 2, 3]
    },
    {
        id: '',
        path: '/',
        exact: true,
        title: 'Dashboard',
        component: Dashboard,
        hasParams: false,
        text: 'Dashboard',
        roleTypes: [1, 2, 3]
    },

    // Hr management
    {
        id: 'CandidateList',
        path: 'CandidateList',
        exact: true,
        title: 'Candidate List',
        component: CandidateList,
        hasParams: false,
        text: 'CandidateList',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'CandidateDetail',
        path: 'CandidateDetail/:id',
        exact: true,
        title: 'Candidate Details',
        component: CandidateDetail,
        hasParams: true,
        text: 'CandidateDetail',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'FollowUp',
        path: 'FollowUp',
        exact: true,
        title: 'Follow-Up',
        component: FollowUp,
        hasParams: false,
        text: 'Candidate Follow Ups',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'ScheduleInterview',
        path: 'ScheduleInterview',
        exact: true,
        title: 'Schedule Interview',
        component: ScheduleInterview,
        hasParams: false,
        text: 'ScheduleInterview',
        roleTypes: [1, 2, 3]
    },

    /** Manage User */
    {
        id: "AddUser",
        path: "/SystemConfiguration/AddUser",
        exact: true,
        title: "User Information",
        component: AddEditUser,
        hasParams: false,
        text: "AddUser",
        roleTypes: [1]
    },
    {
        id: "editUser",
        path: "/SystemConfiguration/EditUser/:id",
        exact: true,
        title: "User Information",
        component: AddEditUser,
        hasParams: false,
        text: "Edit User",
        roleTypes: [1]
    },
    {
        id: "UserList",
        path: "/SystemConfiguration/UserList",
        exact: true,
        title: "User",
        component: ManageUserList,
        hasParams: false,
        text: "UserList",
        roleTypes: [1]
    },

    /** Interview Round */
    {
        id: 'InterviewRound',
        path: '/SystemConfiguration/InterviewRound',
        exact: true,
        title: 'Interview Round',
        component: InterviewRound,
        hasParams: false,
        text: 'Interview Round',
        roleTypes: [1, 2, 3]
    },

    /** Interview Type */
    {
        id: 'InterviewType',
        path: '/SystemConfiguration/InterviewType',
        exact: true,
        title: 'Interview Type',
        component: InterviewType,
        hasParams: false,
        text: 'Interview Type',
        roleTypes: [1, 2, 3]
    },

    //** Manage Skill */
    {
        id: 'ManageSkill',
        path: 'ManageSkill',
        exact: true,
        title: 'Manage Skill',
        component: ManageSkill,
        hasParams: true,
        text: 'SkillList',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'AddManageSkill',
        path: 'AddManageSkill',
        exact: true,
        title: 'Manage Skill Information',
        component: AddEditManageSkill,
        hasParams: true,
        text: 'Add Skill',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'EditManageSkill',
        path: 'EditManageSkill/:id',
        exact: true,
        title: 'Manage Skill Information',
        component: AddEditManageSkill,
        hasParams: true,
        text: 'Edit Skill',
        roleTypes: [1, 2, 3]
    },

    //** Job Title */
    {
        id: 'position',
        path: '/SystemConfiguration/Position',
        exact: true,
        title: 'Position List',
        component: Position,
        hasParams: true,
        text: 'Position',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'AddPosition',
        path: 'AddPosition',
        exact: true,
        title: 'Position Information',
        component: AddEditPosition,
        hasParams: true,
        text: 'Add Position',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'viewPositionDetail',
        path: '/SystemConfiguration/ViewPositionDetail/:id',
        exact: true,
        title: 'Position Detail',
        component: ViewPositionDetail,
        hasParams: true,
        text: 'Position Detail',
        roleTypes: [1, 2, 3]
    },


    //** Testing */
    {
        id: 'TestTableGrid1',
        path: 'TestTableGrid1',
        exact: true,
        title: 'Test Table Grid',
        component: TestTableGrid1,
        hasParams: false,
        text: 'TestTableGrid1',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'TestFormField',
        path: 'TestFormField',
        exact: true,
        title: 'TestFormField',
        component: TestFormField,
        hasParams: false,
        text: 'TestFormField',
        roleTypes: [1, 2, 3]
    },

    //** Manage Channel */
    {
        id: 'ManageChannel',
        path: '/SystemConfiguration/ManageChannel',
        exact: true,
        title: 'Manage Channel',
        component: ManageChannel,
        hasParams: true,
        text: 'ChannelList',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'AddManageChannel',
        path: 'AddManageChannel',
        exact: true,
        title: 'Manage Channel Information',
        component: AddEditManageChannel,
        hasParams: true,
        text: 'Add Channel',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'EditManageChannel',
        path: 'EditManageChannel/:id',
        exact: true,
        title: 'Manage Channel Information',
        component: AddEditManageChannel,
        hasParams: true,
        text: 'Edit Channel',
        roleTypes: [1, 2, 3]
    },

    //** Manage Source */
    {
        id: 'ManageSource',
        path: '/SystemConfiguration/ManageSource',
        exact: true,
        title: 'Manage Source',
        component: ManageSource,
        hasParams: true,
        text: 'SourceList',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'AddManageSource',
        path: 'AddManageSource',
        exact: true,
        title: 'Manage Source Information',
        component: AddEditManageSource,
        hasParams: true,
        text: 'Add Source',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'EditManageSource',
        path: 'EditManageSource/:id',
        exact: true,
        title: 'Manage Source Information',
        component: AddEditManageSource,
        hasParams: true,
        text: 'Edit Source',
        roleTypes: [1, 2, 3]
    },

    //* Rejected Reasons */
    {
        id: 'RejectedReason',
        path: '/SystemConfiguration/RejectedReason',
        exact: true,
        title: 'RejectedReason',
        component: RejectedReason,
        hasParams: false,
        text: 'RejectedReasonList',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'FollowupReason',
        path: '/SystemConfiguration/FollowupReason',
        exact: true,
        title: 'FollowupReason',
        component: FollowupReason,
        hasParams: false,
        text: 'RejectedReasonList',
        roleTypes: [1, 2, 3]
    },
    //* Manage Questions */
    {
        id: 'ManageQuestionList',
        path: 'ManageQuestionList',
        exact: true,
        title: 'Question List',
        component: ManageQuestionList,
        hasParams: false,
        text: 'ManageQuestionList',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'AddEditQuestions',
        path: 'AddEditQuestions',
        exact: true,
        title: 'Add Questions',
        component: AddEditQuestions,
        hasParams: false,
        text: 'AddEditQuestions',
        roleTypes: [1, 2, 3]
    },
    {
        id: "EditQuestions",
        path: "/EditQuestions/:id",
        exact: true,
        title: "Questions Information",
        component: AddEditQuestions,
        hasParams: false,
        text: "Edit Questions",
        roleTypes: [1]
    },
    // {
    //     id: 'MyInterview',
    //     path: 'MyInterview',
    //     exact: true,
    //     title: 'My Interview',
    //     component: MyInterview,
    //     hasParams: false,
    //     text: 'MyInterview',
    //     roleTypes: [3]
    // },
    {
        id: 'MyInterviewDetails',
        path: 'MyInterviewDetails/:id',
        exact: true,
        title: 'My Interview Details',
        component: MyInterviewDetails,
        hasParams: true,
        text: 'MyInterview',
        roleTypes: [3]
    },
    // {
    //     id: 'AllInterview',
    //     path: 'AllInterview',
    //     exact: true,
    //     title: 'All Interview',
    //     component: AllInterview,
    //     hasParams: true,
    //     text: 'AllInterview',
    //     roleTypes: [1, 2]
    // },

    {
        id: 'RecycleBinDelete',
        path: 'RecycleBinDelete',
        exact: true,
        title: 'Recycle Delete',
        component: RecycleBinDelete,
        hasParams: true,
        text: 'RecycleDelete',
        roleTypes: [1, 2, 3]
    },

    //** department */
    {
        id: 'department',
        path: '/SystemConfiguration/Department',
        exact: true,
        title: 'Department List',
        component: Department,
        hasParams: true,
        text: 'Department',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'AddDepartment',
        path: 'AddDepartment',
        exact: true,
        title: 'Department Information',
        component: addEditDepartment,
        hasParams: true,
        text: 'Add Department',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'CandidateReport',
        path: 'CandidateReport',
        exact: true,
        title: 'Candidate Report',
        component: CandidateReport,
        hasParams: true,
        text: 'Candidate Report',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'JobReport',
        path: 'JobReport',
        exact: true,
        title: 'Job Report',
        component: JobReport,
        hasParams: true,
        text: 'Job Report',
        roleTypes: [1, 2, 3]
    },
    {
        id: 'ActivitylogReport',
        path: 'ActivitylogReport',
        exact: true,
        title: 'Activity Log Report',
        component: ActivitylogReport,
        hasParams: true,
        text: 'Activity Log Report',
        roleTypes: [1, 2, 3]
    },
    /** Manage User */
    {
        id: "AddEmail",
        path: "/SystemConfiguration/AddEmail",
        exact: true,
        title: "Email Information",
        component: AddEditEmail,
        hasParams: false,
        text: "AddEmail",
        roleTypes: [1, 2, 3]
    },
    {
        id: "editEmail",
        path: "/SystemConfiguration/EditEmail/:id",
        exact: true,
        title: "Email Information",
        component: AddEditEmail,
        hasParams: false,
        text: "Edit Email",
        roleTypes: [1, 2, 3]
    },
    {
        id: "EmailList",
        path: "/SystemConfiguration/EmailList",
        exact: true,
        title: "Email",
        component: ManageEmailList,
        hasParams: false,
        text: "EmailList",
        roleTypes: [1, 2, 3]
    },

    // Skills pages

    {
        id: "skillCategory",
        path: "skillCategory",
        exact: true,
        title: "Skill Category",
        component: SkillCategory,
        hasParams: false,
        text: "Skill Category",
        roleTypes: [1, 2, 3]
    },
    {
        id: "mainSkill",
        path: "mainSkill",
        exact: true,
        title: "Main Category",
        component: MainSkill,
        hasParams: false,
        text: "Main Category",
        roleTypes: [1, 2, 3]
    },

    //System Action Pages

    {
        id: "systemAction",
        path: "/SystemConfiguration/SystemAction",
        exact: true,
        title: "System Action",
        component: SystemAction,
        hasParams: false,
        text: "System Action",
        roleTypes: [1, 2, 3]
    },
    // Status
    {
        id: 'StatusList',
        path: '/SystemConfiguration/StatusList',
        exact: true,
        title: 'Status List ',
        component: StatusList,
        hasParams: false,
        text: 'Status List',
        roleTypes: [1, 2, 3]
    },
    /** Role Management */
    {
        id: "securityRoles",
        path: "/SystemConfiguration/SecurityRoleManagement",
        exact: true,
        title: "security Roles",
        component: SecurityRoleManagement,
        hasParams: false,
        text: "securityRoles",
        roleTypes: [1, 2, 3]
    },
    {
        id: 'EditPermissions',
        path: '/SystemConfiguration/EditPermissions/:id',
        exact: true,
        title: 'Edit Permissions',
        component: Permissions,
        hasParams: false,
        text: 'Edit Permissions',
        // securityKey: securityKey.PERMISSIONMANAGEMENT
        roleTypes: [1],
    },
]